/**
 * OrbDocCoreConceptsPatternsARDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsPatternsARDocScreen
 */

import { useOrbDocCoreConceptsPatternsARDocScreenLogic } from '@/hooks/traits/useOrbDocCoreConceptsPatternsARDocScreenLogic';
import type { OrbDocCoreConceptsPatternsARDocScreenConfig } from '@/hooks/traits/useOrbDocCoreConceptsPatternsARDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsPatternsARDocView as OrbDocCoreConceptsPatternsARDocViewEntity } from '@app/shared';
import { OrbDocCoreConceptsPatternsARDocBodyView } from '@/components/traits/OrbDocCoreConceptsPatternsARDocBodyView';
import { OrbDocCoreConceptsPatternsARDocFooterView } from '@/components/traits/OrbDocCoreConceptsPatternsARDocFooterView';
import { OrbDocCoreConceptsPatternsARDocHeaderView } from '@/components/traits/OrbDocCoreConceptsPatternsARDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsPatternsARDocScreenViewProps {
  config?: Partial<OrbDocCoreConceptsPatternsARDocScreenConfig>;
}

export function OrbDocCoreConceptsPatternsARDocScreenView({ config: propsConfig }: OrbDocCoreConceptsPatternsARDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsPatternsARDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsPatternsARDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsPatternsAR" trait="OrbDocCoreConceptsPatternsARDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCoreConceptsPatternsARDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCoreConceptsPatternsARDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsPatternsARDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsPatternsARDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsPatternsARDocScreenView;
